<template>
    <content-view>
        <!-- 营销管理-兑换礼券管理－新增兑换活动 -->
        <div class="wrap-container-in">
            <a-form :form="form" class="level-form">
                <a-form-item label="礼券名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input
                        :disabled="isDisable"
                        placeholder="请输入"
                        v-decorator="['name',{rules: [{required: true, max: 50, message: '请输入，不超过50字',}]}]"
                    ></a-input>
                </a-form-item>
                <a-form-item label="兑换商品分类" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select :disabled="isDisable" @change="changeGoodCategory" v-decorator="['goodCategory',{rules: [{required: true, message: '请选择兑换商品分类'}]}]" placeholder="请选择">
                        <a-select-option :value="1">线上票</a-select-option>
                        <a-select-option :value="2">线下票</a-select-option>
                        <a-select-option :value="3">优惠券</a-select-option>
                        <a-select-option :value="4">储值</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item v-show="form.getFieldValue('goodCategory') == 2" label="门票所属门店" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select :disabled="isDisable" @change="changeGoodByShopId" v-decorator="['goodByShopId',{rules: [{required: form.getFieldValue('goodCategory') == 2, message: '请选择门票所属门店'}]}]" placeholder="请选择">
                        <a-select-option v-for="item in shopList" :key="item.id" :value="item.id">{{item.name}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item v-show="form.getFieldValue('goodCategory') == 3" label="优惠券适用类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select :disabled="isDisable" @change="changeGoodType" v-decorator="['goodType',{rules: [{required: form.getFieldValue('goodCategory') == 3, message: '请选择优惠券适用类型'}]}]" placeholder="请选择">
                        <a-select-option value="1">门票优惠券</a-select-option>
                        <a-select-option value="2">餐饮优惠券</a-select-option>
                        <a-select-option value="3">零售优惠券</a-select-option>
                        <a-select-option value="4">课程优惠券</a-select-option>
                        <a-select-option value="10">租赁优惠券</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="兑换商品名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select v-show="form.getFieldValue('goodCategory') == 4 || isDisable" @change="changeGoods" :disabled="isDisable" show-search :filter-option="filterOption" v-decorator="['goodId',{rules: [{required: true, message: '请选择兑换商品名称'}]}]" placeholder="请选择">
                        <a-select-option v-for="item in prizeList" :key="item.prizeId" :value="item.prizeId">{{item.prizeName}}</a-select-option>
                    </a-select>
                    <a-cascader
                        v-if="!isDisable"
                        v-show="form.getFieldValue('goodCategory') != 4"
                        :allowClear="false"
                        :options="options"
                        :show-search="{ filterOption }"
                        :display-render="displayRender"
                        expand-trigger="hover"
                        @change="changeGoods"
                        v-decorator="['goodId',{rules: [{required: true, message: '请选择兑换商品名称'}]}]"
                        placeholder="请选择，支持搜索"
                    />
                </a-form-item>
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <span slot="label">
                        生成兑换数量&nbsp;
                        <a-tooltip title="生成兑换数量不得超过所选物品可用数量">
                            <a-icon type="question-circle-o" />
                        </a-tooltip>
                    </span>
                    <a-row>
                        <a-col :span="5">
                            <a-input-number
                                :precision="0"
                                :disabled="isDisable"
                                :min="1"
                                :max="surplusNum.remainNum > 0 ? surplusNum.remainNum : Infinity"
                                style="width:90px"
                                placeholder="请输入"
                                v-decorator="['num',{rules: [{required: true, message: '请输入生成兑换数量'}, {validator: validatorRule}]}]"
                            />
                        </a-col>
                        <a-col v-show="!isDisable && (form.getFieldValue('goodCategory') == 1 || form.getFieldValue('goodCategory') == 3)" :span="19" style="margin-top: -5px">
                            <a-alert
                            :message="'所选兑换物品的总库量：' + (surplusNum.capacityNum == 999999999 ? '不限量' : surplusNum.capacityNum) + ' ，可用数量：' + (surplusNum.remainNum == 999999999 ? '不限量' : surplusNum.remainNum)"
                            type="warning"
                            />
                        </a-col>
                    </a-row>
                </a-form-item>
                <a-form-item label="兑换有效期" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-radio-group
                        @change="form.setFieldsValue({shelveDate: undefined})"
                        v-decorator="['isHasExpiryDate',{initialValue: 0}]"
                    >
                        <a-radio :value="0">不限期</a-radio>
                        <a-radio :value="1">限期</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item v-show="form.getFieldValue('isHasExpiryDate') == 1" label="设置有效期" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-range-picker
                        style="width: 100%"
                        format="YYYY-MM-DD"
                        v-decorator="['shelveDate',{rules: [{required: form.getFieldValue('isHasExpiryDate') == 1, message: '请选择设置有效期'}]}]"
                    />
                </a-form-item>
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <span slot="label">
                        是否企业团购&nbsp;
                        <a-tooltip title="设置企业团购，兑换礼券可供团购销售">
                            <a-icon type="question-circle-o" />
                        </a-tooltip>
                    </span>
                    <a-radio-group
                        @change="form.setFieldsValue({groupBuyShopType: 0, groupShopIds: undefined})"
                        v-decorator="['isGroupBuy',{initialValue: 0}]"
                    >
                        <a-radio :value="0">否</a-radio>
                        <a-radio :value="1">是</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item v-show="form.getFieldValue('isGroupBuy') == 1" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <span slot="label">
                        团购销售门店&nbsp;
                        <a-tooltip title="指定团购销售门店，兑换礼券将作为各门店的兑换商品展示">
                            <a-icon type="question-circle-o" />
                        </a-tooltip>
                    </span>
                    <a-radio-group
                        @change="form.setFieldsValue({groupShopIds: undefined})"
                        v-decorator="['groupBuyShopType',{initialValue: 0}]"
                    >
                        <a-radio :value="0">全部门店</a-radio>
                        <a-radio :value="1">部分门店</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item v-show="form.getFieldValue('isGroupBuy') == 1 && form.getFieldValue('groupBuyShopType') == 1" label=" " :colon="false" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select
                    mode="multiple"
                    optionFilterProp="children"
                    placeholder="请选择(可多选)"
                    labelInValue
                    v-decorator="['groupShopIds',{rules: [{required: form.getFieldValue('isGroupBuy') == 1 && form.getFieldValue('groupBuyShopType') == 1, message: '请选择团购销售门店'}]}]">
                        <a-select-option v-for="item in shopList" :value="item.id" :key="item.id">{{item.name}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item v-show="form.getFieldValue('goodCategory') == 1 || form.getFieldValue('goodCategory') == 2" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <span slot="label">
                        是否享受买赠&nbsp;
                        <a-tooltip title="兑换时，如有适用该兑换商品买赠营销活动，即可享受">
                            <a-icon type="question-circle-o" />
                        </a-tooltip>
                    </span>
                    <a-radio-group
                        v-decorator="['isHasBuyGet',{initialValue: 0}]"
                    >
                        <a-radio :value="0">否</a-radio>
                        <a-radio :value="1">是</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item class="text-center">
                    <a-button @click="$router.go(-1)">取消</a-button>
                    <a-button type="primary" @click="handleSubmit" :loading="loading">确定</a-button>
                </a-form-item>
            </a-form>
        </div>
    </content-view>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
export default {
    name: "exchangeGiftAdd",
    components: {},
    props: {},
    data() {
        return {
            labelCol: { span: 8 },
            wrapperCol: { span: 10 },
            isDisable: false,
            ticketList: [],
            shopList: [],
            upList: [],
            downList: [],
            upTicketList: [],
            downTicketList: [],
            upShopTicketList: [],
            downShopTicketList: [],
            upCouponList: [],
            downCouponList: [],
            loading: false,
            prizeList: [],
            surplusNum: {
                remainNum: -1,
                capacityNum: -1
            },
            options: []
        };
    },
    computed: {
        id(){
            return this.$route.query.id
        },
        ...mapGetters(["shopId"])
    },
    methods: {
        displayRender({ labels }) {
            return labels[labels.length - 1];
        },
        /**
         * @getShopList 获取门店列表
         */
        getShopList() {
            this.$api.totalPlatform.selectList().then(res => {
                this.shopList = res;
            });
        },
        /**
         * @getTicketList 获取线上票列表
         */
        getTicketList() {
            this.$api.changeCode.getOnlineTicket({
                body: {
                    pageNum: 1,
                    pageSize: 999999,
                    isMiniSell: true,
                }
            })
            .then(res => {
                this.upTicketList = res.list.filter(item => item.isOnShelves);
                this.downTicketList = res.list.filter(item => !item.isOnShelves);

                let upChildren = [], downChildren = [];
                this.upTicketList.forEach(item => {
                    item.id = item.ticketTemplateId;
                    upChildren.push({
                        value: item.ticketTemplateId,
                        label: item.showName + ' - '+ item.name,
                    })
                })
                this.downTicketList.forEach(item => {
                    item.id = item.ticketTemplateId;
                    downChildren.push({
                        value: item.ticketTemplateId,
                        label: item.showName + ' - '+ item.name,
                    })
                })

                this.options = [
                    {
                        value: '上架中',
                        label: '上架中',
                        disabled: upChildren.length == 0,
                        children: upChildren,
                    },
                    {
                        value: '已下架',
                        label: '已下架',
                        disabled: downChildren.length == 0,
                        children: downChildren,
                    },
                ];

                this.upList = this.upTicketList;
                this.downList = this.downTicketList;
            })
        },
        /**
         * @getShopTicketList 获取门店票列表
         */
        getShopTicketList(shopId) {
            this.$api.changeCode.getOnlineTicket({
                body: {
                    pageNum: 1,
                    pageSize: 999999,
                    sellShopId: shopId,
                    isCounterSell: 1,
                }
            }).then(res => {
                this.upShopTicketList = res.list.filter(item => item.isOnShelves);
                this.downShopTicketList = res.list.filter(item => !item.isOnShelves);

                let upChildren = [], downChildren = [];
                this.upShopTicketList.forEach(item => {
                    item.id = item.ticketTemplateId;
                    upChildren.push({
                        value: item.ticketTemplateId,
                        label: item.showName + ' - '+ item.name,
                    })
                })
                this.downShopTicketList.forEach(item => {
                    item.id = item.ticketTemplateId;
                    downChildren.push({
                        value: item.ticketTemplateId,
                        label: item.showName + ' - '+ item.name,
                    })
                })

                this.options = [
                    {
                        value: '上架中',
                        label: '上架中',
                        disabled: upChildren.length == 0,
                        children: upChildren,
                    },
                    {
                        value: '已下架',
                        label: '已下架',
                        disabled: downChildren.length == 0,
                        children: downChildren,
                    },
                ];
                this.upList = this.upShopTicketList;
                this.downList = this.downShopTicketList;
            })
        },
        /**
         * @getCouponList 获取优惠券列表
         */
        getCouponList(suitType) {
            this.$api.changeCode.newCouponList({
                body: {
                    pageNum: 1,
                    pageSize: 999999,
                    suitType: suitType
                }
            })
            .then(res => {
                this.upCouponList = res.list.filter(item => item.couponType == 1);
                this.downCouponList = res.list.filter(item => item.couponType == 2);

                let upChildren = [], downChildren = [];
                this.upCouponList.forEach(item => {
                    upChildren.push({
                        value: item.id,
                        label: item.name,
                    })
                })
                this.downCouponList.forEach(item => {
                    downChildren.push({
                        value: item.id,
                        label: item.name,
                    })
                })

                this.options = [
                    {
                        value: '满减券',
                        label: '满减券',
                        disabled: upChildren.length == 0,
                        children: upChildren,
                    },
                    {
                        value: '折扣券',
                        label: '折扣券',
                        disabled: downChildren.length == 0,
                        children: downChildren,
                    },
                ];
                this.upList = this.upCouponList;
                this.downList = this.downCouponList;
            })
        },
        /**
         * @getPrizeList 获取储值列表
         */
        getPrizeList() {
            this.$api.totalPlatform.getStoredValueCard({}).then(res => {
                res.forEach( el => {
                    el.prizeId = el.id;
                    el.prizeName = el.name;
                })
                this.prizeList = res;
            })
        },
        changeGoodCategory(e) {
            this.form.setFieldsValue({'goodId':undefined});
            if(e == 1) {
                this.getTicketList();
                this.upList = this.upTicketList;
                this.downList = this.downTicketList;
                this.prizeList = [];
            }else if(e == 2) {
                this.upList = this.upShopTicketList;
                this.downList = this.downShopTicketList;
                this.prizeList = [];
            }else if(e == 3) {
                this.upList = this.upCouponList;
                this.downList = this.downCouponList;
                this.prizeList = [];
            }else if(e == 4) {
                this.getPrizeList();
            }
        },
        changeGoodByShopId(e) {
            this.getShopTicketList(e);
        },
        changeGoodType(e) {
            this.getCouponList(e);
        },
        changeGoods(e) {
            let goodId;
            if(this.form.getFieldValue('goodCategory') == 4) {
                goodId = e;
            }else {
                goodId = e[1];
            }
            this.$api.changeCode.getGoodRemainNum({
                query: {
                    goodId: goodId,
                    goodType: this.form.getFieldValue('goodCategory')
                }
            }).then(data => {
                this.surplusNum = data;
            })
            .catch(err => {
            })
        },
        filterOption(input, option) {
            if(option.componentOptions.children[0].text) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            }
        },
        validatorRule(rule, value, callback){
            let num = this.surplusNum.remainNum > 0 ? this.surplusNum.remainNum : Infinity;
            if(value > num) {
                callback('生成的兑换数量，不得超过可用数量')
            }else {
                callback()
            }
        },
        handleSubmit() {
            this.form.validateFields((err, values) => {
                if (err) return;
                if(values.isHasExpiryDate == 1) {
                    values.startExpiryDate = values.shelveDate[0].format("YYYY-MM-DD");
                    values.endExpiryDate = values.shelveDate[1].format("YYYY-MM-DD");
                }
                delete values.shelveDate;

                values.groupBuyShopType = values.isGroupBuy == 0 ? undefined : values.groupBuyShopType;

                values.couponGroupBuyShopList = [];
                values.groupShopIds && values.groupShopIds.forEach(item => {
                    values.couponGroupBuyShopList.push({
                        shopId: item.key,
                        shopName: item.label
                    })
                })
                delete values.groupShopIds

                if(!this.id) {
                    let goods,list = this.upList.concat(this.downList);
                    if(values.goodCategory == 1) {
                        values.goodId = values.goodId[1];
                        goods = list.filter(item => {return item.id == values.goodId})[0];
                        values.goodInnerName = goods.name;
                        values.goodName = goods.showName;
                        delete values.goodType;
                    } else if(values.goodCategory == 2) {
                        values.goodId = values.goodId[1];
                        goods = list.filter(item => {return item.id == values.goodId})[0];
                        values.goodInnerName = goods.name;
                        values.goodName = goods.showName;
                        delete values.goodType;
                    }else if(values.goodCategory == 3) {
                        values.goodId = values.goodId[1];
                        goods = list.filter(item => {return item.id == values.goodId})[0];
                        values.goodInnerName = '-';
                        values.goodName = goods.name;
                    }else if(values.goodCategory == 4) {
                        goods = this.prizeList.filter(item => {return item.prizeId == values.goodId})[0];
                        values.goodInnerName = '-';
                        values.goodName = goods.prizeName;
                    }
                }else {
                    values.goodInnerName = null;
                    values.goodName = null;
                    values.goodId = null;
                    if(values.goodCategory == 1 || values.goodCategory == 2) {
                        delete values.goodType;
                    }
                }

                this.loading = true;
                this.$api.changeCode[this.id?'exchangeGiftEdit':'exchangeGiftAdd']({
                    body: {
                        ...values,
                        id: this.id
                    }
                })
                .then(data => {
                    if(data.flag == false) {
                        this.$message.warning(data.msg);
                        this.loading = false;
                        return
                    }
                    setTimeout(() => {
                        this.$message.success('操作成功');
                        this.$router.go(-1);
                        this.loading = false;
                    }, 3000);
                })
                .catch(err => {
                    this.loading = false;
                })
            });
        },
        getDetail() {
            this.$api.changeCode.exchangeGiftDetail({
                params: {id: this.$route.query.id}
            }).then(res => {
                let formValues = {};
                formValues.name = res.name;
                formValues.goodCategory = res.goodCategory;
                formValues.goodByShopId = res.goodByShopId;
                formValues.goodType = String(res.goodType);
                formValues.num = res.num;
                formValues.isHasExpiryDate = res.isHasExpiryDate;
                formValues.shelveDate = res.startExpiryDate ? [this.$moment(res.startExpiryDate), this.$moment(res.endExpiryDate)] : undefined;
                formValues.isGroupBuy = res.isGroupBuy;
                formValues.groupBuyShopType = res.groupBuyShopType;
                formValues.groupShopIds = [];
                formValues.isHasBuyGet = res.isHasBuyGet;

                res.couponGroupBuyShopList && res.couponGroupBuyShopList.length && res.couponGroupBuyShopList.forEach(item => {
                    formValues.groupShopIds.push({
                        key: Number(item.shopId),
                        label: item.shopName
                    })
                })

                if(res.goodCategory == 1 || res.goodCategory == 2) {
                    formValues.goodId = res.goodName + ' - ' + res.goodInnerName;
                }else {
                    formValues.goodId = res.goodName;
                }

                this.$nextTick(() => {
                    this.form.setFieldsValue(formValues)
                })
            })
        }
    },
    beforeCreate() {
        this.form = this.$form.createForm(this);
    },
    created() {},
    mounted() {
        this.getShopList();
        if (this.id) {
            this.getDetail();
            this.isDisable = true;
        }
    }
};
</script>
<style lang="scss">
</style>
